import { useState } from 'react'
import { LogIn, Volume2 } from 'lucide-react'
import { Button, InfoBand, Input, LogoMark } from '@du/ui'
import { ErroApi } from '../lib/api.js'
import { useSessao } from '../lib/sessao.js'
import { useSomPedido } from '../lib/tempoReal.js'

export function Login({ aoAtivarSom }: { aoAtivarSom: () => void }) {
  const { entrar } = useSessao()
  const { ligado } = useSomPedido()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault()
    setErro(null)
    setEnviando(true)
    try {
      // Ativa o som no MESMO gesto do login: o navegador só libera áudio
      // depois de uma interação, e depois disso ninguém mais clica em nada
      // até o primeiro pedido chegar — que é justamente quando o som importa.
      aoAtivarSom()
      await entrar(email, senha)
    } catch (x) {
      setErro(x instanceof ErroApi ? x.message : 'Não consegui conectar. Confira a internet.')
      setEnviando(false)
    }
  }

  return (
    <div className="login">
      <form className="login__caixa" onSubmit={enviar}>
        <LogoMark largura={200} />
        <h1 className="login__titulo">Portal de gestão</h1>

        <Input
          rotulo="E-mail"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
        />
        <Input
          rotulo="Senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
          {...(erro ? { erro } : {})}
        />

        <Button type="submit" icone={LogIn} tamanho="lg" larguraTotal carregando={enviando}>
          Entrar
        </Button>

        <p className="login__som">
          <Volume2 size={16} strokeWidth={1} aria-hidden /> {ligado ? 'Som ativado' : 'O som de pedido novo é ativado ao entrar'}
        </p>
      </form>

      <InfoBand tom="preto">
        <span>Dú Lanches · Av. dos Estudantes, 400 — Caieiras/SP</span>
      </InfoBand>
    </div>
  )
}
